import React from 'react';

export const IconFileImage: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
        <rect x="1.5" y="1.5" width="13" height="13" rx="1" stroke="currentColor" strokeWidth="1.25" />
        <circle cx="5.5" cy="5.5" r="1.25" stroke="currentColor" strokeWidth="1.1" />
        <path
            d="M1.5 11L5 7.5L8 10.5L10.5 8L14.5 12"
            stroke="currentColor"
            strokeWidth="1.1"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
